import { render } from "./RemoveWorkingSiteUserAssignment.vue?vue&type=template&id=1dcd4aca&scoped=true&ts=true&lang=pug"
import script from "./RemoveWorkingSiteUserAssignment.vue?vue&type=script&lang=ts"
export * from "./RemoveWorkingSiteUserAssignment.vue?vue&type=script&lang=ts"

import "./RemoveWorkingSiteUserAssignment.vue?vue&type=style&index=0&id=1dcd4aca&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dcd4aca"]])

export default __exports__